import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ArtificialIntelligenceIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ArtificialIntelligence",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m16.97 2.58 2.66 4.86c1.14 2.09 2.86 3.8 4.94 4.94l4.86 2.66c.77.42.77 1.53 0 1.94l-4.85 2.66c-2.09 1.14-3.8 2.86-4.94 4.94l-2.66 4.85c-.42.77-1.53.77-1.94 0l-2.66-4.86c-1.14-2.09-2.86-3.8-4.94-4.94l-4.86-2.66c-.77-.42-.77-1.53 0-1.94l4.86-2.66c2.09-1.14 3.8-2.86 4.94-4.94l2.64-4.85c.42-.77 1.53-.77 1.94 0Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M30.71 17c-8.82 0-16-7.18-16-16a1.14 1.14 0 1 1 2.28 0c0 7.56 6.15 13.71 13.71 13.71a1.14 1.14 0 1 1 0 2.28Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.86 31.86c-.63 0-1.14-.51-1.14-1.14 0-8.82 7.18-16 16-16a1.14 1.14 0 1 1 0 2.28c-7.56 0-13.71 6.15-13.71 13.71 0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.86 31.86c-.63 0-1.14-.51-1.14-1.14 0-7.56-6.15-13.71-13.71-13.71a1.14 1.14 0 1 1 0-2.28c8.82 0 16 7.18 16 16 0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M1 17a1.14 1.14 0 1 1 0-2.28c7.56 0 13.71-6.15 13.71-13.71a1.14 1.14 0 1 1 2.28 0c0 8.82-7.18 16-16 16Z"
      })]
    })
  }));
};